import { treeMethods } from "utils"

const sortThisBranchCategories = (categories) => (
  treeMethods.flattenTree(
    { children: treeMethods.arrayToTree(categories) }
  )
)


export default sortThisBranchCategories